export * from './delete-template.command.module';
export * from './service';
export * from './component';